var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userPriceChange)?_c('MainDashboard'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }